<template>
  <div>
    <div class="modal is-active">
      <div @click="close" class="modal-background"></div>
      <div class="modal-content">
        <div class="card">
          <div class="card-content">
            <div class="content">
              <div class="field">
                <label class="label">Name</label>
                <div class="control">
                  <input class="input" type="text" v-model="preference.name" placeholder="name">
                </div>
              </div>
              <div class="field">
                <label class="label">Keyword</label>
                <div class="control">
                  <input class="input" type="text" v-model="preference.keyword" placeholder="keyword">
                </div>
              </div>
              <div class="field">
                <label class="label">Category</label>
                <div class="control">
                  <select class="select" v-model="preference.parent_id" placeholder="keyword">
                    <option v-for="(pref, key) in preferences" :key="key" :value="pref.id">{{ pref.name }}</option>
                    <option :value="null">No parent</option>
                  </select>
                </div>
              </div>
              <div class="field">
                <p class="control">
                  <button @click="createPreference" class="button is-success">
                    Create
                  </button>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button @click="close" class="modal-close is-large" aria-label="close"></button>
    </div>
  </div>
</template>

<script>
import {createPreference} from "../../api/api";

export default {
  props: ['preferences'],
  data() {
    return {
      preference: {
        name: '',
        keyword: '',
        parent_id: null,
      }
    }
  },
  methods: {
    close() {
      this.$emit("close")
    },
    async createPreference() {
      try {
        await createPreference(this.preference)
        this.$emit('preferences:created')
        this.close()
      } catch (e) {
        console.error(e)
      }
    }
  }
}
</script>
